import axiosClient from "./axiosClient";

// API dòng nhắc trên thẻ sản phẩm từng sàn (shopee/lazada/shopeefood/tiktok).
// App & web đọc file tĩnh /img/product-notes.json; admin sửa qua endpoint này.
const productNotesApi = {
    getConfig() {
        return axiosClient.get("product-notes");
    },
    updateConfig(payload) {
        return axiosClient.put("product-notes", payload);
    },
};

export default productNotesApi;
